import { logger } from '../logger';

/**
 * Logger for Analytics-related operations
 * Use this for analytics tracking, data exports, and reporting
 */
const analyticsLogger = logger.child('Analytics');

export default analyticsLogger;
